import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import type { ClockBasis } from './clock-basis';

// «Horario: Local | Origen» — which clock a flight list reads in (PO 2026-10-28: «que los
// cálculos los haga basado en el horario del operador y que pueda switchear con un botón»).
// The /flights board and the declare picker share it, and the choice (`useClockBasis`).

export function ClockSwitch({ clock, onChange }: { clock: ClockBasis; onChange: (c: ClockBasis) => void }) {
  const { t } = useTranslation('network');
  return (
    <div
      role="group"
      aria-label={t('board.clock.label')}
      className="inline-flex items-center gap-1 rounded-md border border-border p-0.5 text-xs"
      data-testid="board-clock-switch"
    >
      <span className="px-1.5 text-muted-foreground">{t('board.clock.label')}</span>
      {(['local', 'origin'] as const).map((c) => (
        <button
          key={c}
          type="button"
          aria-pressed={clock === c}
          title={t(`board.clock.${c}Hint`)}
          onClick={() => onChange(c)}
          className={cn(
            'min-h-8 rounded px-2.5 font-semibold',
            clock === c ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted',
          )}
          data-testid={`board-clock-${c}`}
        >
          {t(`board.clock.${c}`)}
        </button>
      ))}
    </div>
  );
}

